import { useQuery } from "@tanstack/react-query";
import { getDetectByEvent } from "../api/detect";
import { DateFilter } from "../types/types";

interface PropsParams extends DateFilter {
  resetFetch?: () => void;
  fetch: boolean;
  ownerID?: string;
  area: string;
  device_pid?: string;
  mobility_seq?: number;
  groupId?: string;
  mobility_code?: number;
}
const useGetDetectByEvent = ({
  startDate,
  endDate,
  ownerID,
  area,
  mobility_seq,
  groupId,
  mobility_code,
}: PropsParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "detect",
      `detectByEvent`,
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `ownerID-${ownerID}`,
      `area-${area}`,
      `mobility_seq-${mobility_seq}`,
      `groupId-${groupId}`,
      `mobility_code-${mobility_code}`,
    ],
    queryFn: () =>
      getDetectByEvent({
        startDate,
        endDate,
        ownerID,
        area,
        mobility_seq,
        groupId,
        mobility_code,
      }),

    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });

  return { data, isLoading, isSuccess };
};

export default useGetDetectByEvent;
